<template>
  <v-row>
    <v-col cols="12">
      <v-menu
        v-model="menu2"
        :close-on-content-click="false"
        :nudge-right="10"
        transition="fab-transition"
        offset-y
        min-width="200px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="formatCalendarDia"
          
            append-icon="mdi-calendar-today"
            readonly
            disabled
            class="mt-1 font-weight-black"
            v-bind="attrs"
            v-on="on"
            hide-details
            dense
            outlined
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="edititem.FechaVisita"
          :first-day-of-week="1"
          reactive
          @input="menu2 = false"
          color="#002f6c"
          :locale="localidad"
          :min="minimo"
          :max="fecha_max"
          :landscape="landscape"
        ></v-date-picker>
      </v-menu>
    </v-col>
    <v-divider></v-divider>
    <v-col cols="12" sm="4">
      <v-radio-group
        v-model="edititem.TipoVisita"
        class="mt-n1 ml-2"
        hide-details
      >
        <template v-slot:label>
          <strong>Atención al cliente</strong>
        </template>

        <v-radio
          v-show="item.id !== undefined"
          v-for="item of atencioncli"
          :key="item.id"
          :label="`${item.des}`"
        ></v-radio>
      </v-radio-group>
    </v-col>
    <v-col cols="12" sm="8">
      <strong>Detalle de la Visita {{ $vuetify.breakpoint.name }}</strong>
      <v-row no-gutters class="mt-n4">
        <v-col cols="12" sm="5">
          <v-checkbox
            v-model="edititem.IndPresupuesto"
            label="Presupuesto"
            hide-details
          ></v-checkbox>
          <v-checkbox
            v-model="edititem.IndBoletin"
            class="mt-1"
            label="Publicidad"
            hide-details
          ></v-checkbox>
          <v-checkbox
            v-model="edititem.IndCobros"
            label="Cobros"
            class="mt-1"
            hide-details
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="6">
          <v-checkbox
            v-model="edititem.IndPedidos"
            label="Pedidos"
            hide-details
          ></v-checkbox>
          <v-checkbox
            v-model="edititem.IndLlamar"
            label="Llamar nuevamente"
            class="mt-1"
            hide-details
          ></v-checkbox>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12">
      <v-textarea
        outlined
        name="input-7-4"
        label="Observaciones"
        v-model="edititem.Notas"
      ></v-textarea>
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      detalleselect: [],
      detalles: [
        { id: 0, des: "Pedido" },
        { id: 1, des: "Cobro" },
        { id: 2, des: "Material Publicidad" },
        { id: 3, des: "Presupuesto" },
        { id: 4, des: "Llamar despues" },
      ],
      atencioncli: [
        {},
        { id: 1, des: "Presencial" },
        { id: 2, des: "Telefonico" },
        { id: 3, des: "Email" },
 
      ],
      menu2: false,
      fecha_max: new Date()
        .toLocaleString("sv", { timeZoneName: "short" })
        .substr(0, 10), //fecha dia
      fecha_hoy: new Date()
        .toLocaleString("sv", { timeZoneName: "short" })
        .substr(0, 10), //fecha dia
    };
  },
  computed: {
    ...mapState("mod_agendaquery", [
      "landscape",
      "maximo",
      "minimo",
      "localidad",
    ]),

    formatCalendarDia() {
      moment.locale("es");
      return moment(this.edititem.FechaVisita).format("L");
    },
  },
  props: {
    idcli: Number,
    iddist: Number,
    edititem: Object,
  },
};
</script>

